export default {
  methods: {
    /**
     * @description 组件属性默认值
     */
    handleAttribute(attribute, defaultValue) {
      if (attribute === false || attribute === 0 || attribute === '') {
        return attribute
      }
      return attribute || defaultValue
    },
    handleList(list) {
      if (typeof list === 'function') {
        return list()
      }
      if (Array.isArray(list)) {
        return list
      }
      return []
    },
    handleData(value) {
      if (typeof value === 'function') {
        return value()
      }
      if (value === false || value === 0 || value === '') {
        return value
      }
      return value || ''
    }
  }
}
